import { useEffect, useRef } from 'react';

import { useClientEnvironment } from '#/contexts/UserEnvironmentContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { useEmbedSearchWidgetLayoutRouteLoaderData } from '#/modules/embedSearchWidget/hooks/useEmbedSearchWidgetLayoutRouteLoaderData';
import {
  useSearchActions,
  useSearchLocation,
} from '#/modules/search/contexts/SearchContext';
import { searchGetInitialLocation } from '#/modules/search/helpers/searchGetInitialLocation';

export function UpdateSearchLocationFromLocalStorageGlobalHandler() {
  const { embedSearchWidgetSearchLocation } =
    useEmbedSearchWidgetLayoutRouteLoaderData();
  const { locale } = useI18n();
  const { clientEnvironment } = useClientEnvironment();

  const searchLocation = useSearchLocation();
  const { updateSearchLocation } = useSearchActions();

  const triggeredRef = useRef(false);

  useEffect(() => {
    if (!clientEnvironment || triggeredRef.current) return;
    triggeredRef.current = true;

    if (!searchLocation) {
      void searchGetInitialLocation(
        clientEnvironment.guessedLocation,
        locale,
        embedSearchWidgetSearchLocation,
      ).then((initialSearchLocation) => {
        updateSearchLocation(initialSearchLocation, false);
        return;
      });
    }
  }, [
    embedSearchWidgetSearchLocation,
    clientEnvironment,
    locale,
    searchLocation,
    updateSearchLocation,
  ]);

  return null;
}
